import {
    PUBLIC_CHAMELEON_CLIENT_API_URL,
    PUBLIC_NARCO_CLIENT_API_URL,
    PUBLIC_NAUTILUS_CLIENT_API_URL,
    PUBLIC_NEO_CLIENT_API_URL,
    PUBLIC_PAM_CLIENT_API_URL,
    PUBLIC_SCR_CLIENT_API_URL,
    PUBLIC_SQUIDWARD_CLIENT_API_URL,
    REMOTE_CHAMELEON_API_URL,
    REMOTE_NAUTILUS_API_URL,
} from '@/app/_constants/urls'

import { ServiceName } from './types'

const IS_SSR = typeof window === 'undefined'

export const SERVICE_URLS: Record<ServiceName, string | undefined> = {
    'ntl-ssr': REMOTE_NAUTILUS_API_URL,
    'cml-ssr': REMOTE_CHAMELEON_API_URL,
    pam: PUBLIC_PAM_CLIENT_API_URL,
    ntl: PUBLIC_NAUTILUS_CLIENT_API_URL,
    sqw: PUBLIC_SQUIDWARD_CLIENT_API_URL,
    cml: PUBLIC_CHAMELEON_CLIENT_API_URL,
    nrc: PUBLIC_NARCO_CLIENT_API_URL,
    neo: PUBLIC_NEO_CLIENT_API_URL,
    scr: PUBLIC_SCR_CLIENT_API_URL,
}

export function selectAPIService(): Record<'ntl' | 'cml', ServiceName> {
    return {
        ntl: IS_SSR ? 'ntl-ssr' : 'ntl',
        cml: IS_SSR ? 'cml-ssr' : 'cml',
    }
}

export function getServiceUrl(serviceName: ServiceName): string | undefined {
    return SERVICE_URLS[serviceName]
}
